import { Link } from "react-router-dom"
import HeroSlider from "../components/HeroSlider"
import ServicesSection from "../components/ServicesSection"
// import AwardsSection from "../components/AwardsSection"
import DepartmentsSection from "../components/DepartmentsSection"
import DiagnosticsSection from "../components/DiagnosticsSection"
import OffersSection from "../components/OffersSection.js"
import InsuranceSection from "../components/InsuranceSection.js"
import NewsSection from "../components/NewsSection"
// import AarogyasriSection from "../components/AarogyasriSection"
// import DepartmentCards from "../components/DepartmentCards"
// import InsuranceLogos from "../components/InsuranceLogos"
import TestimonialsSection from "../components/TestimonialsSection"
import { useState, useEffect, useCallback } from "react"
import { useAppointment } from '../context/AppointmentContext'
import SEO from './SEO';

import { ChevronLeft, ChevronRight } from "lucide-react"



const Home = () => {
   const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "description": "MAMS Hospitals - A legacy of healing, compassion, and excellence in healthcare since 1992.",
    "foundingDate": "1996",
    "founder": {
      "@type": "Person",
      "name": "Sri Puvvada Nageswara Rao"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally, Hyderabad, Telangana – 500090",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+91-7399999981",
        "email": "contact@mamshospitals.com",
        "availableLanguage": ["English", "Hindi", "Telugu"]
      }
    ],
    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },


  {
     "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mamshospitals.com/"
  },
  "headline": "MAMS Hospitals – Where Healing Meets Excellence",
  "description": "MAMS Hospitals in Hyderabad offers comprehensive healthcare across multiple specialties with compassionate and advanced medical care.",
  "image": "https://mamshospitals.com/path-to-main-image.jpg",
  "author": {
    "@type": "Organization",
    "name": "MAMS Hospitals"
  },
  "publisher": {
    "@type": "Organization",
    "name": "MAMS Hospitals",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mamshospitals.com/MAMS-Logo.png"
    }
  },
  "datePublished": "1996-05-01",
  "dateModified": "2025-09-10",
  "keywords": [
    "MAMS Hospitals Hyderabad",
    "super-specialty hospital Bachupally",
    "comprehensive healthcare Hyderabad",
    "emergency care Telangana"
  ],
  "articleSection": [
    "Medical Services",
    "Diagnostic & Health Packages",
    "Patient Satisfaction",
    "Insurance Partners"
  ],
  "about": {
    "@type": "MedicalOrganization",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "telephone": "+91-7399999981",
      "availableLanguage": ["English", "Hindi", "Telugu"]
    },
    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  }

  }
];



    const [currentSlide, setCurrentSlide] = useState(0)
  const [isLoaded, setIsLoaded] = useState(false)
  const [isPaused, setIsPaused] = useState(false)
  const { open: openAppointment } = useAppointment()

  // Auto-open the appointment popup when the site loads
  useEffect(() => {
    const timer = setTimeout(() => {
      openAppointment()
    }, 500)
    return () => clearTimeout(timer)
  }, [])

  const slides = [

       {
      id: 1,
      // title: "Advanced Medical Care",
      // subtitle: "State-of-the-art Facilities",
    //  description:
    //     "MAMS Hospitals combines compassionate care with cutting-edge medical expertise to provide comprehensive healthcare services.",
      image: "https://mamshospitals.com//MAMS_Banner_4.jpg",
      ctaText: "Meet Our Doctors",
      ctaLink: "/doctors",
      ctaSecondaryText: "Contact Us",
      ctaSecondaryLink: "/contact",
    },

    {
      id: 2,
      // title: "MAMS Hospitals",
      // subtitle: "Where Healing Meets Excellence",
      // description:
      //   "MAMS Hospitals combines compassionate care with cutting-edge medical expertise to provide comprehensive healthcare services.",
      image: "https://mamshospitals.com//img-2.jpg",
      ctaText: " Know About Us",
      ctaLink: "/about",
      ctaSecondaryText: "Contact Us",
      ctaSecondaryLink: "/contact",
    },
    {
      id: 3,
      // title: "Advanced Medical Care",
      // subtitle: "State-of-the-art Facilities",
      // description:
      //   "Our expert specialists ensure you receive the highest standard of medical treatment with personalized care.",
     image: "https://mamshospitals.com//img-3.jpg",
      ctaText: "Meet Our Doctors",
      ctaLink: "/doctors",
      ctaSecondaryText: "Contact Us",
      ctaSecondaryLink: "/contact",
    },
    {
      id: 4,
      // title: "Advanced Medical Care",
      // subtitle: "State-of-the-art Facilities",
      // description:
      //   "We're committed to the health and wellbeing of your entire family, providing compassionate care at every stage of life.",
      image: "https://mamshospitals.com//MAMS_Banner_1.jpg",
      ctaText: "Our Departments",
      ctaLink: "/departments",
      ctaSecondaryText: "Contact Us",
      ctaSecondaryLink: "/contact",
    },
    {
      id: 5,
      // title: "Advanced Medical Care",
      // subtitle: "State-of-the-art Facilities",
      //  description:
      //   "MAMS Hospitals combines compassionate care with cutting-edge medical expertise to provide comprehensive healthcare services.",
      
     image: "https://mamshospitals.com//MAMS_Banner_2.jpg",
      ctaText: "Meet Our Doctors",
      ctaLink: "/doctors",
      ctaSecondaryText: "Contact Us",
      ctaSecondaryLink: "/contact",
    },
    {
      id: 6,
      // title: "Advanced Medical Care",
      // subtitle: "State-of-the-art Facilities",
      // description:
      //   "We're committed to the health and wellbeing of your entire family, providing compassionate care at every stage of life.",
      image: "https://mamshospitals.com//MAMS_Banner_3.jpg",
      ctaText: " Know About Us",
      ctaLink: "/about",
      ctaSecondaryText: "Contact Us",
      ctaSecondaryLink: "/contact",
    },
    {
      id: 7,
      // title: "Family-Centered Care",
      // subtitle: "Healthy Families, Happy Lives",
      // description:
      //   "We're committed to the health and wellbeing of your entire family, providing compassionate care at every stage of life.",
      image: "https://mamshospitals.com//img-1.jpg",
      ctaText: "Our Departments",
      ctaLink: "/departments",
      ctaSecondaryText: "Contact Us",
      ctaSecondaryLink: "/contact",
    },
    {
      id: 8,
      // title: "Advanced Medical Care",
      // subtitle: "State-of-the-art Facilities",
      // description:
      //   "Our expert specialists ensure you receive the highest standard of medical treatment with personalized care.",
      image: "https://mamshospitals.com//MAMS_Banner_5.jpg",
      ctaText: "Meet Our Doctors",
      ctaLink: "/doctors",
      ctaSecondaryText: "Contact Us",
      ctaSecondaryLink: "/contact",
    },
  ]
  // Function to go to next slide
  const nextSlide = useCallback(() => {
    try {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1))
    } catch (error) {
      console.error("Error in nextSlide:", error)
    }
  }, [slides.length])

  // Function to go to previous slide
  const prevSlide = useCallback(() => {
    try {
      setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1))
    } catch (error) {
      console.error("Error in prevSlide:", error)
    }
  }, [slides.length])

  // Function to go to a specific slide
  const goToSlide = useCallback(
    (index) => {
      try {
        if (index >= 0 && index < slides.length) {
          setCurrentSlide(index)
        }
      } catch (error) {
        console.error("Error in goToSlide:", error)
      }
    },
    [slides.length],
  )

  // Auto-play functionality
  useEffect(() => {
    setIsLoaded(true)

    if (!isPaused) {
      const interval = setInterval(() => {
        nextSlide()
      }, 5000)

      return () => {
        clearInterval(interval)
      }
    }

    return undefined
  }, [isPaused, nextSlide])

  // Handle errors gracefully
  if (!slides || !Array.isArray(slides) || slides.length === 0) {
    return (
      <div className="relative bg-apple-gray-50 h-[500px] flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-semibold text-apple-gray-500">Welcome to MAMS Hospitals</h2>
          <p className="text-apple-gray-400 mt-2">Where Healing Meets Excellence</p>
        </div>
      </div>
    )
  }


  
  return (
    <>
      <SEO
        title="MAMS Hospitals | Best Multispeciality Hospital in Bachupally, Hyderabad"
    description="MAMS Hospitals is a leading multispeciality hospital in Bachupally, Hyderabad offering 24×7 emergency care, cardiology, orthopaedics, pediatrics & more."
        keywords="MAMS Hospitals,
          MAMS Hospital Hyderabad,
          MAMS Hospital Bachupally,
          multispeciality hospital in Hyderabad,
          best hospital in Bachupally,
          24x7 emergency hospital Hyderabad,
          teaching hospital in Hyderabad,
          ICU hospital Hyderabad,
          cardiology hospital Hyderabad,
          orthopaedics hospital Hyderabad,
          pediatrics hospital Bachupally,
          general medicine hospital Hyderabad,
          medical college hospital Hyderabad,
          hospital near Bachupally
          "
        schema={schema}
      canonicalUrl="https://mamshospitals.com/"
      />

    <div className="flex flex-col min-h-screen">
      {/* Hero Slider */}
      <HeroSlider />

      {/* About Section */}
       <section className="py-8 md:py-16 px-0 md:px-4 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-2">About MAMS Hospitals</h2>
            <p className="text-apple-gray-400 max-w-2xl mx-auto">
              A legacy of healing, compassion, and excellence in healthcare since 1996.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-apple-gray-400 mb-4">
                Established in 1996 by Sri Puvvada Nageswara Rao, Mamata Educational Society has grown into a beacon of
                accessible and quality healthcare. A visionary leader, advocate, and former legislator, Sri Rao's
                commitment to education and social welfare led to the foundation of MAMS Hospital — now a trusted name
                in compassionate and advanced medical care for all, especially the underserved.
              </p>
              <p className="text-apple-gray-400 mb-6">
                MAMS General Hospital, part of this legacy, stands as a center of excellence offering comprehensive
                healthcare services at minimal or no cost to those in need.
              </p>

              <div class="md:w-full mb-4">
              <div className="bg-apple-gray-50 p-6 rounded-3xl border border-apple-gray-100">
                <h3 className="text-2xl font-semibold text-apple-gray-500 mb-6">Why Choose MAMS Hospitals?</h3>
                <ul className="space-y-4">
                  <li className="flex gap-3">
                    <div className="bg-apple-gray-100 p-2 rounded-full h-10 w-10 flex items-center justify-center text-apple-teal">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3"></path>
                        <path d="M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4"></path>
                        <circle cx="20" cy="10" r="2"></circle>
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-semibold text-apple-gray-500">Experienced Specialists</h4>
                      <p className="text-sm text-apple-gray-400">
                        A team of highly qualified doctors providing accurate diagnosis and expert care.
                      </p>
                    </div>
                  </li>
                  <li className="flex gap-3">
                    <div className="bg-apple-gray-100 p-2 rounded-full h-10 w-10 flex items-center justify-center text-apple-teal">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M6 22V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v20"></path>
                        <path d="M6 12H4"></path>
                        <path d="M6 17H4"></path>
                        <path d="M6 7H4"></path>
                        <path d="M22 22V6a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v16"></path>
                        <path d="M17 22H6"></path>
                        <path d="M17 12h-2"></path>
                        <path d="M17 17h-2"></path>
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-semibold text-apple-gray-500">Superspecialty Expertise</h4>
                      <p className="text-sm text-apple-gray-400">
                        From general medicine to super-specialty care, we cater to diverse medical needs under one roof.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

              <Link to="/about">
                <div className="apple-button">Learn More About Us</div>
              </Link>
            </div>

            <div className="relative">
              {/* <div className="aspect-video rounded-3xl overflow-hidden shadow-lg bg-apple-gray-100">
                <video className="w-full h-full object-cover" controls poster="/placeholder.svg?height=400&width=600">
                  <source src="/mams-hospital-video.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                
              </div> */}
              <div className="iframevideo relative overflow-hidden h-[200px] md:h-[300px] "
      //         onMouseEnter={() => setIsPaused(true)}
      // onMouseLeave={() => setIsPaused(false)}
              >

       {/* video Section */}
      <div className="container mx-auto px-4">
       <div className="iframevideo"> 
        
        <video
          className="w-auto"
            autoPlay
            muted
            loop
            playsInline
            controls
          >
            <source src="/sample-video.MOV" type="video/mp4" />
            </video>
      </div>
      </div> 


</div>

              <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-2xl shadow-lg border border-apple-gray-100 z-[999]">
                <div className="text-center">
                  <div className="text-2xl font-bold text-apple-teal">25+</div>
                  <div className="text-sm text-apple-gray-400">Years of Care</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    {/* Services Section */}
      <ServicesSection />

      {/* InsuranceSection  */}
      <InsuranceSection />

      {/* Departments-sections */}
      {/* <DepartmentsSection /> */}

      {/* DiagnosticsSection */}
      {/* <DiagnosticsSection /> */}

      {/* OffersSection */}
      {/* <OffersSection /> */}


      {/* News Section */}
      <NewsSection />

      {/* TestimonialsSection  */}
      <TestimonialsSection />

    </div>
    </>
  )
}

export default Home
